import { cliTemplate, llmTemplate, reactAntdPro, reactMantineTailwind, reactTailwind, reactTanstack, reactThreeMaplibre, reactVisglMaplibre, vueTailwind } from "./package";

export const createList = [
  { name: cliTemplate.name, description: cliTemplate.description },
  { name: vueTailwind.name, description: vueTailwind.description },
  { name: llmTemplate.name, description: llmTemplate.description },
  { name: reactAntdPro.name, description: reactAntdPro.description },
  { name: reactMantineTailwind.name, description: reactMantineTailwind.description },
  { name: reactTailwind.name, description: reactTailwind.description },
  { name: reactTanstack.name, description: reactTanstack.description },
  { name: reactThreeMaplibre.name, description: reactThreeMaplibre.description },
  { name: reactVisglMaplibre.name, description: reactVisglMaplibre.description },
];
